import React, {
  lazy,
} from 'react';
import {
  Navigate,
  RouteObject,
} from 'react-router-dom';
import LazyLoadComponent from 'core/components/LazyLoadComponent';
import {
  DASHBOARD_PATHS,
} from 'views/EMR/access';

function DashboardIndexRedirect() {
  return <Navigate to={DASHBOARD_PATHS.OVERVIEW} replace />;
}

const dashboardRoutes: RouteObject[] = [{
  path: '/pcc/overview',
  element: (
    <LazyLoadComponent Component={lazy(() => import('./PCCOverview'))} />
  ),
}, {
  path: '/pcc/rtm',
  element: (
    <LazyLoadComponent Component={lazy(() => import('./RTM'))} />
  ),
}, {
  // Keep the reminders page available for later, but hide the route for now.
  // {
  //   path: '/pcc/reminders',
  //   element: (
  //     <LazyLoadComponent Component={lazy(() => import('./Reminders'))} />
  //   ),
  // },
  path: '/pcc/tempo',
  element: (
    <LazyLoadComponent Component={lazy(() => import('./Tempo'))} />
  ),
}, {
  path: '/pcc/ccm',
  element: (
    <LazyLoadComponent Component={lazy(() => import('./CcmMonthly'))} />
  ),
}, {
  path: '/pcc',
  element: <DashboardIndexRedirect />,
}];

export default dashboardRoutes;
